import axios from 'axios';
import * as Sentry from "@sentry/react";

import { storage } from "./config/storage";
import { GC } from './config/gamecentreService';

const baseUrl = process.env.REACT_APP_API_ENDPOINT;

export const backendAxiosInstance = axios.create({
    baseURL: baseUrl,
    timeout: 3000
})

const logError = (error) => {
    if (error?.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        Sentry.setExtra("response", error.response)
        Sentry.captureException(error)
    } else if (error?.request) {
        // The request was made but no response was received
        Sentry.setExtra("request", error.request)
        Sentry.captureException(error)
    } else {
        // Something happened in setting up the request that triggered an Error
        Sentry.captureException(error?.message)
    }
}

export const sendStats = async ({
    level,
    totalTime,
    totalServed,
    incorrectServed,
    correctServed,
    isLevelCleared,
    totalAccuracy,
    totalLevelCleared,
    totalAverageMoveTime,
    firstMoveTime,
    extraLevelData = {
        burntPatty: 0,
        points: 0,
        totalMoves: 0,
        totalIngredientsPlaced: 0,
        correctIngredientsPlaced: 0,
        incorrectIngredientsPlaced: 0,
        pattiesPlaced: 0,
        bunsPlaced: 0,
        pattiesTrashed: 0,
    }
}) => {
    const payload =  {
        "gameData": {
            "levelData": [
                {
                    "level": level || 1,
                    "bonusTimeThreshold": 0,
                    "totalTime": totalTime || 0,
                    "totalServed": totalServed || 0,
                    "correctServed": correctServed,
                    "incorrectServed": incorrectServed || 0,
                    "isLevelCleared": isLevelCleared || false,
                    "burntPatty": extraLevelData.burntPatty,
                    "totalPoints": extraLevelData.points,
                    "totalMoves": extraLevelData.totalMoves,
                    "totalIngredientsPlaced": extraLevelData.totalIngredientsPlaced,
                    "correctIngredientsPlaced": extraLevelData.correctIngredientsPlaced,
                    "incorrectIngredientsPlaced": extraLevelData.incorrectIngredientsPlaced,
                    "pattiesPlaced": extraLevelData.pattiesPlaced,
                    "bunsPlaced": extraLevelData.bunsPlaced,
                    "pattiesTrashed": extraLevelData.pattiesTrashed,
                    
                }
            ],
            "totalMoves": totalServed || 0,
            "totalCorrectMoves": correctServed || 0,
            "totalIncorrectMoves": incorrectServed || 0,
            "totalAccuracy": totalAccuracy || 0,
            "totalLevelCleared": totalLevelCleared || 0,
            "totalTimeTaken": totalTime || 0,
            "totalAverageMoveTime": totalAverageMoveTime || 0,
            "firstMoveTime": firstMoveTime || 0
        }
    }
    GC.sendGameDataSaveMessage(payload);
}